<template>
  <same-as :reference="reference"/>
</template>

<script>
import SameAs from './empty_house_council_tax.vue'

export default {
  components: { SameAs },
  props: ['reference']
}
</script>
